import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Manitoulin Horse Enthusiasts Club';
const SITE_URL = 'https://mhec.ca';
const DEFAULT_DESCRIPTION = 'Join the Manitoulin Horse Enthusiasts Club - your premier equestrian community on Manitoulin Island. Register for horse shows, clinics, and events.';
const DEFAULT_IMAGE = 'https://images.unsplash.com/photo-1661260100858-718952c5b5ae?w=1200&h=630&fit=crop';

export const SEO = ({ 
  title, 
  description = DEFAULT_DESCRIPTION, 
  image = DEFAULT_IMAGE,
  url,
  type = 'website'
}) => {
  const pageTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} - Horse Shows & Events on Manitoulin Island`;
  const pageUrl = url ? `${SITE_URL}${url}` : SITE_URL;
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={pageUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_CA" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={pageUrl} />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <meta name="geo.region" content="CA-ON" />
      <meta name="geo.placename" content="Manitoulin Island" />
    </Helmet>
  );
};

export default SEO;
